import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Gamepad2, Globe } from "lucide-react";

const DiscordIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M20.317 4.369a19.79 19.79 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.211.375-.444.865-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.1 13.1 0 0 1-1.872-.892.077.077 0 0 1-.008-.128c.126-.094.252-.192.372-.291a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.009c.12.099.246.198.373.292a.077.077 0 0 1-.006.127 12.3 12.3 0 0 1-1.873.891.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.84 19.84 0 0 0 6.002-3.03.077.077 0 0 0 .032-.056c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.028ZM8.02 15.331c-1.183 0-2.157-1.086-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.332-.956 2.418-2.157 2.418Zm7.975 0c-1.183 0-2.157-1.086-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.332-.946 2.418-2.157 2.418Z" />
  </svg>
);

export const CreatorCard = ({ creator, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    data-testid={`creator-card-${creator.id}`}
    className="group relative block border border-border bg-card overflow-hidden hover:border-volt transition-colors duration-300"
  >
    <Link to={`/creators/${creator.id}`} className="block">
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={creator.avatar_url || "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=800"}
          alt={creator.name}
          className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
        {(creator.tier === "Lead") && (
          <span className="absolute top-4 left-4 bg-volt text-white font-mono text-[9px] tracking-[0.2em] uppercase px-2.5 py-1">Lead</span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-volt">@{creator.roblox_username || "roblox"}</span>
          <h3 className="font-display font-extrabold text-2xl tracking-tight uppercase mt-1">{creator.name}</h3>
        </div>
      </div>
    </Link>

    <div className="absolute top-4 right-4 flex gap-2 z-10">
      {creator.roblox_url && (
        <a href={creator.roblox_url} target="_blank" rel="noreferrer" data-testid={`creator-roblox-link-${creator.id}`} title="Roblox profile"
          className="w-9 h-9 flex items-center justify-center border border-white/20 bg-black/50 backdrop-blur-md text-white hover:bg-volt hover:border-volt transition-colors duration-300">
          <Gamepad2 className="w-4 h-4" />
        </a>
      )}
      {creator.discord_url && (
        <a href={creator.discord_url} target="_blank" rel="noreferrer" data-testid={`creator-discord-link-${creator.id}`} title="Join their comms"
          className="w-9 h-9 flex items-center justify-center border border-white/20 bg-black/50 backdrop-blur-md text-white hover:bg-volt hover:border-volt transition-colors duration-300">
          <DiscordIcon className="w-4 h-4" />
        </a>
      )}
      {creator.portfolio_url && (
        <a href={creator.portfolio_url} target="_blank" rel="noreferrer" data-testid={`creator-portfolio-link-${creator.id}`} title="Portfolio"
          className="w-9 h-9 flex items-center justify-center border border-white/20 bg-black/50 backdrop-blur-md text-white hover:bg-volt hover:border-volt transition-colors duration-300">
          <Globe className="w-4 h-4" />
        </a>
      )}
    </div>
  </motion.div>
);
